// extracted by mini-css-extract-plugin
export default {"root":"FieldCheckboxGroup_root__I-Rn1","list":"FieldCheckboxGroup_list__X2M5S","twoColumns":"FieldCheckboxGroup_twoColumns__kqfd3","item":"FieldCheckboxGroup_item__h4QUl"};